import { ServiceConfig } from 'constants/shared/ServiceConfig';
import * as Yup from 'yup';

export const lessonReportTemplateAddValidationSchema = Yup.object({
  templateTitle: Yup.string()
    .required('수업 리포트 템플릿 제목을 입력해 주세요.')
    .max(
      ServiceConfig.LessonReport.maxTemplateTitleLength,
      `제목은 최대 ${ServiceConfig.LessonReport.maxTemplateTitleLength}자까지 입력할 수 있습니다.`,
    ),
  publicTitle: Yup.string()
    .required('학부모에게 보여지는 제목을 입력해 주세요.')
    .max(
      ServiceConfig.LessonReport.maxTemplateTitleLength,
      `제목은 최대 ${ServiceConfig.LessonReport.maxTemplateTitleLength}자까지 입력할 수 있습니다.`,
    ),
});

export const initialLessonReportTemplateAddFormValues: {
  templateTitle: string;
  publicTitle: string;
} = {
  templateTitle: '',
  publicTitle: '',
};

export type LessonReportTemplateFormValuesT = typeof initialLessonReportTemplateAddFormValues;
